// Highlights elements briefly when a new MQTT message for their topic group arrives.
// Usage: v-flash="'key'" on an element, pulse('key') when data comes in.
const targets = new Map()

export function pulse(key) {
  for (const el of targets.get(key) || []) {
    el.classList.remove('mqtt-flash')
    void el.offsetWidth // restart the CSS animation
    el.classList.add('mqtt-flash')
  }
}

export const flash = {
  mounted(el, binding) {
    if (!targets.has(binding.value)) targets.set(binding.value, new Set())
    targets.get(binding.value).add(el)
  },
  unmounted(el, binding) {
    const set = targets.get(binding.value)
    if (set) set.delete(el)
  }
}
